"use strict";
/**
 * Field validation utilities for LingoShade
 * Centralized validation helpers for forms across all apps
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEmail = isValidEmail;
exports.isValidPassword = isValidPassword;
exports.getEmailError = getEmailError;
exports.getPasswordError = getPasswordError;
exports.validateTextLength = validateTextLength;
exports.validatePasswordConfirmation = validatePasswordConfirmation;
exports.validateName = validateName;
const userValidation_1 = require("./userValidation");
/**
 * Simple email format validation (returns boolean)
 * Convenient for forms that need quick yes/no validation
 */
function isValidEmail(email) {
    return (0, userValidation_1.validateEmail)(email).isValid;
}
/**
 * Simple password validation (returns boolean)
 * Convenient for forms that need quick validation
 */
function isValidPassword(password) {
    return (0, userValidation_1.validatePassword)(password).isValid;
}
/**
 * Get email validation error message
 * Returns first error message or null if valid
 */
function getEmailError(email) {
    const result = (0, userValidation_1.validateEmail)(email);
    return result.errors.length > 0 ? result.errors[0] : null;
}
/**
 * Get password validation error message
 * Returns first error message or null if valid
 */
function getPasswordError(password) {
    const result = (0, userValidation_1.validatePassword)(password);
    return result.errors.length > 0 ? result.errors[0] : null;
}
/**
 * Validate text input with length constraints
 */
function validateTextLength(text, minLength = 0, maxLength = 1000) {
    if (text.length < minLength) {
        return {
            isValid: false,
            error: `Text must be at least ${minLength} characters long`,
        };
    }
    if (text.length > maxLength) {
        return {
            isValid: false,
            error: `Text must be no more than ${maxLength} characters long`,
        };
    }
    return { isValid: true };
}
/**
 * Password confirmation validation
 */
function validatePasswordConfirmation(password, confirmPassword) {
    if (password !== confirmPassword) {
        return {
            isValid: false,
            error: "Passwords do not match",
        };
    }
    return { isValid: true };
}
/**
 * Name validation (for first/last names)
 */
function validateName(name) {
    if (!name.trim()) {
        return {
            isValid: false,
            error: "Name is required",
        };
    }
    if (name.trim().length < 2) {
        return {
            isValid: false,
            error: "Name must be at least 2 characters long",
        };
    }
    if (name.length > 50) {
        return {
            isValid: false,
            error: "Name must be no more than 50 characters long",
        };
    }
    return { isValid: true };
}
//# sourceMappingURL=fieldValidation.js.map